import React, { useEffect, useMemo } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Route, Routes } from 'react-router-dom'
import { css, StyleSheet } from 'aphrodite'
import { AppDispatch } from 'components/store/state/store'
import {
  fetchCliniques,
  fetchOptions,
  fetchRegions,
  fetchTreatments,
  setHideUrlStatus,
  updateLocale,
  updateTreatments,
} from 'components/core/state/actions'
import { getCurrentStep } from 'components/core/state/selectors'
import Step1 from 'components/steps/Step1'
import Step2 from 'components/steps/Step2'
import Step3 from 'components/steps/Step3'
import Step4 from 'components/steps/Step4'
import constants from 'utils/constants'
import useResponsive from 'hooks/useResponsive'
import { AvailableLanguage, ITreatment } from 'components/core/types'

const mapState = (state) => ({
  currentStep: getCurrentStep(state),
})

const mapDispatch = (dispatch: AppDispatch) => ({
  forceTreatments: (treatments: ITreatment[]) => dispatch(updateTreatments(treatments)),
  getCliniques: () => dispatch(fetchCliniques()),
  getLanguage: (lang) => dispatch(updateLocale(lang)),
  getOptions: () => dispatch(fetchOptions()),
  getRegions: () => dispatch(fetchRegions()),
  getTreatments: () => dispatch(fetchTreatments()),
  setHideUrl: (status: boolean) => dispatch(setHideUrlStatus(status)),
})
const connector = connect(mapState, mapDispatch)

interface ApplicationProps extends ConnectedProps<typeof connector> {
  lang: AvailableLanguage,
  treatments: ITreatment[],
  hideUrl: boolean,
}
const Application = ({
  currentStep,
  lang,
  treatments,
  forceTreatments,
  getCliniques,
  getLanguage,
  getOptions,
  getRegions,
  getTreatments,
  hideUrl,
  setHideUrl,
}: ApplicationProps) => {
  useEffect(() => {
    forceTreatments(treatments || [])
    getLanguage(lang)
    getCliniques()
    getRegions()
    getOptions()
    getTreatments()
    setHideUrl(hideUrl)
    window.onbeforeunload = () => localStorage.clear()
  }, [])
  const { compareTag } = useResponsive()
  const Component = useMemo(() => {
    switch (currentStep) {
      case 1: {
        return Step1
      }
      case 2: {
        return Step2
      }
      case 3: {
        return Step3
      }
      case 4: {
        return Step4
      }
      default:
        return Step1
    }
  }, [currentStep])

  const paddingVertical = compareTag('md') ? '100px' : '30px'
  const styles = StyleSheet.create({
    body: {
      backgroundColor: constants.colors.background,
      paddingTop: paddingVertical,
      paddingBottom: paddingVertical,
      position: 'relative',
      justifyContent: 'center',
      fontSize: 'calc(10px + 2vmin)',
      fontFamily: 'Public Sans, sans-serif',
      color: 'white',
      textRendering: 'optimizeLegibility',
    },
    links: {
      color: '#61dafb',
    },
  })

  return (
    <div className={`tw-antialiased ${css(styles.body)}`}>
      <Routes>
        <Route path="*" element={<Component />} />
      </Routes>
    </div>
  )
}

export default connector(Application)
